// Portada del menú (plan Pro). Se achica en el navegador antes de subirla, así el menú
// carga rápido en el celular aunque el dueño suba una foto de la cámara.
export const COVER_MAX_WIDTH = 1600;
// Lo que se acepta elegir. Después de achicarla tiene que quedar en menos de 5 MB (storage.rules).
export const COVER_MAX_INPUT_BYTES = 20 * 1024 * 1024;

// Tamaño final: hasta COVER_MAX_WIDTH de ancho, sin agrandar fotos chicas.
export const coverSize = (width, height, max = COVER_MAX_WIDTH) => {
    if (!width || !height) return null;
    const scale = Math.min(1, max / width);
    return { width: Math.round(width * scale), height: Math.round(height * scale) };
}

// Problema con el archivo elegido, o null si se puede usar.
export const coverFileProblem = (file) => {
    if (!file) return "Elegí una foto para la portada.";
    if (!String(file.type || "").startsWith("image/")) return "La portada tiene que ser una foto (JPG, PNG o WebP).";
    if (file.size > COVER_MAX_INPUT_BYTES) return "La foto pesa más de 20 MB. Probá con una más liviana.";
    return null;
}

const loadImage = (file) => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => resolve({ img, url });
    img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("No se pudo leer la imagen"));
    };
    img.src = url;
});

// Devuelve un JPEG de hasta COVER_MAX_WIDTH de ancho. Si el navegador no puede leer
// la foto (por ejemplo HEIC en Chrome), devuelve el archivo original.
// `max` y `name` los usan también las fotos de los productos (gallery.js).
export const shrinkCover = async (file, max = COVER_MAX_WIDTH, name = "portada.jpg") => {
    let loaded;
    try {
        loaded = await loadImage(file);
    } catch (error) {
        return file;
    }
    try {
        const size = coverSize(loaded.img.naturalWidth, loaded.img.naturalHeight, max);
        if (!size) return file;
        const canvas = document.createElement("canvas");
        canvas.width = size.width;
        canvas.height = size.height;
        const ctx = canvas.getContext("2d");
        // Fondo blanco por si el PNG tiene partes transparentes.
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, size.width, size.height);
        ctx.drawImage(loaded.img, 0, 0, size.width, size.height);
        const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.82));
        if (!blob) return file;
        return new File([blob], name, { type: "image/jpeg" });
    } finally {
        URL.revokeObjectURL(loaded.url);
    }
}

// Solo los negocios Pro muestran la portada. Si un negocio deja Pro la portada queda
// guardada, y vuelve a verse si se suscribe de nuevo.
export const coverOf = (business) => business?.subscribed === true && business?.portada ? business.portada : "";
